import { Injectable } from '@angular/core';
import { SessionService } from 'src/app/Core/services/session.service';
import { GtmEvent } from '../interfaces/gtm-event';
import { PublicShared } from './PublicShared';
import { Application } from './application.service';

@Injectable({
  providedIn: 'root',
})
export class GtmService {

  App: Application = SessionService.GetApplication;

  constructor(private session: SessionService) {}

  private getCookie(name: string): string | null {
    const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const match = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  }

  private getAttributionValue(cookieKey: string, localStorageKey?: string): string | null {
    const cookieValue = this.getCookie(cookieKey);
    if (cookieValue && cookieValue !== '' && cookieValue !== 'null') {
      return cookieValue;
    }

    const storedValue = localStorage.getItem(localStorageKey ?? cookieKey);
    if (storedValue && storedValue !== '' && storedValue !== 'null') {
      return storedValue;
    }

    return null;
  }

  private getUtmAttributionProperties() {
    return {
      utm_source: this.getAttributionValue('utm_source', 'utmSource'),
      utm_medium: this.getAttributionValue('utm_medium', 'utmMedium'),
      utm_campaign: this.getAttributionValue('utm_campaign', 'utmCampaign'),
      utm_term: this.getAttributionValue('utm_term', 'utmTerm'),
      utm_content: this.getAttributionValue('utm_content', 'utmContent'),
      gclid: this.getAttributionValue('gclid', 'googClickID'),
      gbraid: this.getAttributionValue('gbraid'),
      wbraid: this.getAttributionValue('wbraid'),
      fbclid: this.getAttributionValue('fbclid'),
      gad_source: this.getAttributionValue('gad_source'),
      gad_campaignid: this.getAttributionValue('gad_campaignid'),
      landing_page: this.getAttributionValue('landing_page'),
      landing_page_referrer: this.getAttributionValue('landing_page_referrer'),
    };
  }
  
  private getSharedProperties() {
    return {
      product_selected: PublicShared.GProduct(Number(sessionStorage.getItem('productId'))),
      ...SessionService.GetCustomer.UserID ? { userID :  SessionService.GetCustomer.UserID } : {},
      enquiryID: this.session.clientId,
      devicePlatform:  this.session.runPlatform,
      idfa: sessionStorage.getItem('idfa'),
      att_status: sessionStorage.getItem('att_status'),
      adid: sessionStorage.getItem('adid'),
      idfv: sessionStorage.getItem('idfv'),
      primary_dedupe_token: sessionStorage.getItem('primary_dedupe_token'),
      have_mortgage: this.App.HasMortage ?? false,
      saudi_national: sessionStorage.getItem('civilId')?.startsWith('1') ?? false,
      ...this.getUtmAttributionProperties(),
    };
  }

  private createGtmEvent(eventName: string, properties: Partial<GtmEvent> = {}) {
  return {
    event: eventName, 
    ...this.getSharedProperties(),
    ...properties,
  };
}

  pushEvent(eventName: string, fireOnlyOnce : boolean = true, dynamicProperties: Partial<GtmEvent> = {}): void {
    let shouldFire = false;
    if (fireOnlyOnce) {
      var hasFired = sessionStorage.getItem('lastFiredEvent') === eventName;
      if(!hasFired){
        shouldFire = true;
        sessionStorage.setItem('lastFiredEvent', eventName);
      }
      else
        console.log(`GTM event ${eventName} has already been fired`);
    }
    else 
      shouldFire = true;
    
    if(shouldFire)
    {
      const gtmEvent = this.createGtmEvent(eventName, dynamicProperties);
      if (SessionService.isGoogleTagEnabled) {
        try{
          (<any>window).dataLayer.push(gtmEvent);
          console.log(`Fired GTM event ${gtmEvent.event}`, gtmEvent);
        }
        catch (error) {
          console.log(error)
        }
      }
      else
        console.error('GTM dataLayer is not defined.');
    }
  }
}